import { companyPolicies as policies } from 'helpers';
import Schema from './schema';


export default class Company extends Schema {

  constructor(values) {
    super(policies, values);

    this.setDtoDefinition({
      name: '',
      description: '',
    });
  }

  setValues(data) {
    this.values = this.dtoDefinition;
    this.setDefaultValues(data);
  }
}
